import React, { useState, ReactElement } from "react";
import { Button } from "./StyledComp";
import "../../Styles/StyledComps.css";

interface IProps {
  icon: ReactElement;
  buttontext: string;
  isDisabled?: boolean;
  type?: "button" | "reset" | "submit"
  onClick: () => void;
}

const ButtonWithIcon: React.FC<IProps> = (props) => {
  const handleOnClick = () => {
    props.onClick();
  };

  return (
    <Button
      className="button-wrapper"
      type={props.type || "submit"}
      onClick={handleOnClick}
      disabled={props.isDisabled}
    >
      <span className="button-icon">{props.icon}</span>
      <span>{props.buttontext}</span>
    </Button>
  );
};

export default ButtonWithIcon;
